<template>
  <div>
    <v-dialog
      v-model="loading_download"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="#4EBCA6"
        dark
        class="pt-1"
      >
        <v-card-text class="text-center">
          กำลังเซ็นเอกสาร
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog" width="70%">
      <v-app-bar dense elevation="4" style="background-color: #00a99d">
        <h2 style="color: white">เอกสารผลการตรวจสุขภาพ</h2>
        <v-spacer></v-spacer>
        <v-btn v-if="check_role()" color="white" @click="sign_pdf()">
          <span style="color: #00a99d" class="font-14">เซ็นเอกสาร</span>
        </v-btn>
        <v-btn
          icon
          @click="close_dialog()"
          style="margin-left: 10px; color: white"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-app-bar>
      <!-- <iframe title="cert_doc" style="overflow:hidden" height="520px" width="600px" :src="`data:application/pdf;base64,${doc_pdf}`"></iframe> -->

      <v-card class="pa-5">
        <pdf
          :src="`data:application/pdf;base64,${doc_pdf}`"
          v-for="i in num_pages"
          :key="i"
          :page="i"
        ></pdf>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import pdf from "@teckel/vue-pdf";
import { mapState } from 'vuex';
export default {
  name: "PreviewPDF",
  components: { pdf },
  data: () => ({
    dialog: false,
    doc_pdf: "",
    payload_data: "",
    num_pages: null,
    loading_download: false,
    cid: ""
  }),
  computed: {
    ...mapState(["detailPhysicalExam"]),
    pagtotals() {
      return this.totals;
    },
  },
  mounted() {},
  methods: {
    open(cert_doc, item, doc_code) {
      this.payload_data = item;
      this.cid  = item.cid;
      this.dialog = true;
      this.doc_pdf = cert_doc;
      if (doc_code === "HEALTH_CHECK") {
        this.num_pages = 9;
      } else if (doc_code === "MEDICAL_CERTIFICATE") {
        this.num_pages = 1;
      }
    },
    check_role() {
      if (sessionStorage.getItem("role_name") === "แพทย์") {
        return true;
      } else if (sessionStorage.getItem("role_name") === "พยาบาล") {
        return false;
      }
    },
    async sign_pdf() {
      this.loading_download = true
      const payload = {
        doc_code: "HEALTH_CHECK",
        id: this.detailPhysicalExam._id,
        biz_id: sessionStorage.getItem("biz_id"),
        pdf_data: this.doc_pdf,
        cid: this.cid
      };
      await this.axios
        .post(
          `${process.env.VUE_APP_BACKEND_URL}/v1/sign/pdfdata`,
          payload,
        )
        .then(() => {
          this.loading_download = false
          this.$swal
            .fire({
              icon: "success",
              title: "เซ็นเอกสารสำเร็จ",
              showConfirmButton: false,
              timer: 1000,
            })
            .then(() => {
              this.$emit("goBack")
              this.$router.push({ name: "health-check" });
            });
        })
        .catch((error) => {
          this.loading_download = false
          if (error.response.data.message === "Not found credential") {
            this.$swal.fire({
              icon: "error",
              title: `<span style="font-size: 20px;">ไม่มีสิทธ์ในการเซ็นเอกสาร</span>`,
              showConfirmButton: false,
              timer: 2000,
            })
          } else if (error.response.data.message == "Patient not found"){
            this.$swal.fire({
              icon: "error",
              title: `<span style="font-size: 20px;">ไม่พบ oneid ของผู้ป่วย</span>`,
              showConfirmButton: false,
              timer: 2000,
            })
          } else if (error.response.data.message == "This user has not a signature image!!"){
            this.$swal.fire({
              icon: "error",
              title: `<span style="font-size: 20px;">ไม่พบลายเซ็นแพทย์ ไปที่ตั้งค่า</span>`,
              showConfirmButton: false,
              timer: 2000,
            })
          } else {
            this.$swal.fire({
              icon: "error",
              title: `<span style="font-size: 20px;">เกิดข้อผิดพลาด</span>`,
              showConfirmButton: false,
              timer: 2000,
            })
          }
          console.log(error);
        });
    },
    close_dialog() {
      this.$emit("goBack")
      this.$router.replace('/health-check');
      this.dialog = false;
    },
  },
};
</script>
